module.exports = __webpack_public_path__ + "img/custom-01.6642aeb5.jpg";